<script setup lang="ts">
  import DetailSection from "./DetailSection.vue";
  import DetailItem from "./DetailItem.vue";
  import type { Histo } from "@/components/Admin/Histo/HistoDataTable/types";

  defineProps<{
    histo: Histo;
  }>();
</script>

<template>
  <DetailSection title="Owners">
    <DetailItem
      label="Sales"
      :value="histo.hs_owner_sales" />
    <DetailItem
      label="CSM"
      :value="histo.hs_owner_csm" />
    <DetailItem
      label="TM"
      :value="histo.hs_owner_tm" />
  </DetailSection>
</template>
